import CoreAPI from '../Core/CoreAPI';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

class AuthAPI {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_IDENTITY_SERVER')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL) this.setApi(new CoreAPI(getSessionItem('API_IDENTITY_SERVER')));

    return this.api;
  }

  async getRestrictionAccessByGV () {
    let result;

    try {
      result = await this.getAPI().getInstance().get(`api/account/v1/broker/verify-block`);
      result = result.data;
    } catch (e) {
      result = true;
    }

    return result;
  }
};

const api = new AuthAPI();
export default api;